<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Purchase Return Vouchers</h4>
                <p class="text-subtitle-1">List of return vouchers</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
            <v-menu offset-y :close-on-content-click="false" min-width="300">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            depressed
                            block
                            >
                            <v-icon left>mdi-magnify</v-icon>
                            search
                        </v-btn>
                    </template>
                    <v-card 
                        flat
                        >
                        <v-card-title>Search</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        label="code"
                                        v-model="form.code"
                                        dense
                                        hide-details="auto"
                                        outlined
                                        @keypress.enter="handleSearch"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <DatePicker
                                        label="From"
                                        v-model="form.from"
                                        outlined
                                        dense
                                        clearable
                                        hide-details="auto"/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <DatePicker
                                        label="To"
                                        v-model="form.to"
                                        outlined
                                        dense
                                        clearable
                                        hide-details="auto"/>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn  color="primary" block @click="handleSearch">Submit</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="items"
                    :page.sync="page"
                    :server-items-length="serverItemsLength"
                    :options.sync="options"
                    :loading="loading"
                    @dblclick:row="handleRowDblClick"
                    disable-sort
                    >
                    <template v-slot:[`item.code`]="{item}" v-if="hasPermission(perm.good_return.read)">
                        <v-btn icon @click="handleRowClick(item)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.code}}
                    </template>
                    <template v-slot:[`item.state`]="{item}">
                        <PStatus :state="item.state"/>
                    </template>
                    <template v-slot:[`item.purchase_order_code`]="{item}">
                        <span class="text-decoration-underline font-weight-bold" @click="showPurchaseOrder(item)" style="cursor: pointer">
                            {{item.purchase_order_code}}
                        </span>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import permission from './../../../data/permissions'
import service from './../../../services/purchase/goodReturn';
import DatePicker from './../../../components/common/DatePicker.vue';
import PStatus from './../../../components/common/PStatus.vue';
import authorize from '../../../utils/authorize';
export default {
    components: {
        DatePicker,
        PStatus
    },
    data() {
        return {
            headers: [
                { text: "Code", value: "code" },
                { text: "Supplier", value: "supplier" },
                { text: "Warehouse", value: "warehouse" },
                { text: "Purchase Order", value: "purchase_order_code" },
                { text: "State", value: "state" }
            ],
            items:[],
            page: 1,
            serverItemsLength: 0,
            options: {},
            form: {
                code: ""
            },
            loading: false,
            perm: permission,
        }
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.fetchGoodReturns();
            }
        }
    },
    methods: {
        fetchGoodReturns() {
            this.items = [];
            this.loading = true;
            service.list({...this.options, ...this.form}).then(response => {
                this.items = response.data.data;
                this.serverItemsLength = response.data.count
            }).finally(() => {
                this.loading = false;
            })
        },
        handleOpenDisplay(id) {
            if(!this.hasPermission(this.perm.good_return.read)) return;
            this.$router.push({name: "GoodReturnDisplay", params: {id}})
        },
        handleRowClick(item) {
            this.handleOpenDisplay(item.id)
        },
        handleRowDblClick(e, {item}) {
            this.handleOpenDisplay(item.id)
        },
        handleSearch() {
            this.page = 1;
            this.fetchGoodReturns();
        },
        showPurchaseOrder(item) {
            this.$router.push({ name: "PurchaseOrderDisplay", params: { id: item.purchase_order_id } });
        },
        hasPermission(code){
            return authorize(code)
        }
    }
}
</script>

<style>

</style>